module.exports = __webpack_public_path__ + "static/media/ic_document_card.fcf15970.svg";